import { Spin } from 'antd';
import Group from '../Group';
import { CSSProperties, ReactNode, useEffect, useState } from 'react';

interface Props {
  messages?: ReactNode[];
  interval?: number;
  style?: CSSProperties;
  disableLoading?: boolean;
  loaderSize?: 'default' | 'small' | 'large';
  posAbsolute?: boolean;
}

const ModalLoadingOverlay: React.FC<Props> = ({
  messages = ['Carregando...'],
  interval = 5000,
  style,
  disableLoading = false,
  loaderSize = 'default',
  posAbsolute = false,
}) => {
  const [message, setMessage] = useState(messages[0]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMessage(messages[current]);

      setCurrent((prevCurrent) => {
        if (prevCurrent === messages.length - 1) {
          return 0;
        }
        return prevCurrent + 1;
      });
    }, interval);

    return () => clearTimeout(timeout);
  }, [messages, interval, current]);

  const styleAbsolute: CSSProperties = posAbsolute
    ? { position: 'absolute', width: '100%', height: '100%' }
    : {};

  return (
    <div
      className="modal-loading-overlay"
      style={{
        padding: 24,
        ...style,
        ...styleAbsolute,
      }}
    >
      <Group gap={24} align="center">
        {!disableLoading && <Spin size={loaderSize} />}
        <h2>{message}</h2>
      </Group>
    </div>
  );
};

export default ModalLoadingOverlay;
